<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><a class="link-effect" [routerLink]="['/solicitudes-contratista']">Mis Solicitudes</a></li>
                <li><span class="link-effect">Registrar</span></li>
            </ol>
        </div>
    </div>
  </div>
  <div class="content">
    <div class="block">
        <div class="block-header">
            <h3 class="block-title">Registrar Solicitud</h3>
        </div>
        <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
            <div class="block-content">
                <app-solicitud-master [model]="model" [disabled]="false" [escontratista]="true" ></app-solicitud-master>
            </div>
            <div class="block-content">
                <div class="form-horizontal">
                    <mat-divider class="engie-divider"></mat-divider>
                </div>
                <div class="form-horizontal pad-25">
                    <div class="form-group">
                        <div class="col-sm-12 text-right">
        
                          <button type="submit" class="btn btn-naranja" (click)="save()" mat-raised-button><mat-icon>folder_open</mat-icon> Iniciar Solicitud</button>
                          <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" (click)="save()">Guardar</button>
                          <button type="submit" id="btnEnviar" class="btn btn-celeste" (click)="submit()">Enviar</button> -->
                          <a class="btn btn-naranja2" mat-raised-button (click)="closed()"  ><mat-icon>exit_to_app</mat-icon> Salir</a>
                        </div>
                    </div>
                </div>
              </div>
        </form>
    </div>
</div>